import { render, staticRenderFns } from "./sign.vue?vue&type=template&id=65832687&"
import script from "./sign.vue?vue&type=script&lang=ts&"
export * from "./sign.vue?vue&type=script&lang=ts&"
import style0 from "./sign.vue?vue&type=style&index=0&id=65832687&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports